import { FaUser } from "react-icons/fa";
import "./Matching.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { UPLOADS_URL } from "../../config";
import { getMediaUrl } from "../../http/media";



export default function MatchingCard({ profile, loading }) {

  const { t } = useTranslation();
  const translateProfileValue = (value) => {
    if (value === null || value === undefined || value === "") return "-";
    return String(value)
      .split(",")
      .map((item) => {
        const key = item.trim();
        return t(key, { defaultValue: key });
      })
      .join(" • ");
  };

  const ROLE_LABELS = {
    lawyer: t("matchCard.lawyer"),
    athlete: t("matchCard.athlete"),
    club: t("matchCard.club"),
    brand: t("matchCard.brand"),
    staff: t("matchCard.staff"),
    fan: t("matchCard.fan"),
    media: t("matchCard.media")
  };

  const lawyerStatuses =
    profile?.role === "lawyer" &&
      profile?.status
      ? JSON.parse(profile.status)
      : [];

  const navigate = useNavigate();

  if (loading) {

    console.log(profile);
    return (
      <div className="match-card">
        <div className="match-header">
          <div className="skeleton avatar"></div>
          <div>
            <div className="skeleton text"></div>
            <div className="skeleton text small"></div>
          </div>
        </div>

        <div className="match-body">
          <div className="skeleton text"></div>
          <div className="skeleton text"></div>
        </div>
      </div>
    );
  }
  return (
    <div className="match-card-mine">
      <div className="match-header">
        {profile.image ? (
          <img
            // src={`${UPLOADS_URL}/${profile.image}`}
            src={getMediaUrl(profile.image)}
          />
        ) : (
          <div className="avatar-placeholder">
            <FaUser />
          </div>
        )}
        <div>
          <h3>{profile.full_name}</h3>
          <span className={`role-badge ${profile.role?.toLowerCase()}`}>
            {ROLE_LABELS[profile.role] || profile.role}
          </span>
        </div>
      </div>

      <div className="match-body">
        {profile.role === "athlete" && (
          <>
            <p><strong>{t("matchCard.sport")} :</strong> {translateProfileValue(profile.sport)}</p>
            <p><strong>{t("matchCard.position")} :</strong> {translateProfileValue(profile.position)}</p>
            <p><strong>{t("matchCard.level")} :</strong> {translateProfileValue(profile.level)}</p>
          </>
        )}

        {profile.role === "club" && (
          <>
            <p><strong>{t("matchCard.sport")} :</strong> {translateProfileValue(profile.sport)}</p>
            <p><strong>{t("matchCard.level")} :</strong> {translateProfileValue(profile.level)}</p>
            <p><strong>{t("matchCard.country")} :</strong> {translateProfileValue(profile.country)}</p>
          </>
        )}

        {profile.role === "lawyer" && (
          <>
            <p>
              <strong>{t("matchCard.speciality")} : &nbsp;</strong>
              {profile.role === "lawyer"
                ? lawyerStatuses.map(s => t(s)).join(" • ")
                : profile.role}
            </p>
            <p><strong>{t("matchCard.sport")} :</strong> {translateProfileValue(profile.sport)}</p>
          </>
        )}

        {profile.role === "brand" && (
          <>
            <p><strong>{t("matchCard.sector")} :</strong> {translateProfileValue(profile.sector)}</p>
          </>
        )}

        {profile.role === "media" && (
          <>
            <p><strong>{t("matchCard.type")} :</strong> {translateProfileValue(profile.type)}</p>
            <p><strong>{t("matchCard.status")} :</strong> {translateProfileValue(profile.status)}</p>
          </>
        )}

        {profile.role === "staff" && (
          <>
            <p><strong>{t("matchCard.sport")} :</strong> {translateProfileValue(profile.sport)}</p>
            <p><strong>{t("matchCard.status")} :</strong> {translateProfileValue(profile.status)}</p>
            <p><strong>{t("matchCard.licence")} :</strong> {translateProfileValue(profile.licence)}</p>
          </>
        )}
      </div>

      <div className="match-footer">
        <button
          className="btn-primary"
          onClick={() => navigate(`/user/${profile.username}`)}
        >
          {t("matchCard.viewProfile")}
        </button>
      </div>

      <span className="match-badge">{t("matchCard.confirmedMatch")}</span>
    </div>
  );
}
